export default (function (node) {
  return node.nodeName && node.nodeName.toLowerCase();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/nodeName.js
// module id = 529
// module chunks = 31